import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoginService } from 'lps-navigation';
import { IDateRange } from '../action-history-queue/interfaces/date-range.interface';
import { EnvironmentService } from '../core/enviroment/environment.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardReportsService {
  public api_uri = this.environmentService.getEnvVar('base_url_roulette');
  public BASE_URL = '/dashboard';

  constructor(private http: HttpClient, private loginService: LoginService, private environmentService: EnvironmentService) { }

  getReceivedLeadAgents(page: number, maxResults: number, order: string, dateRange: IDateRange, company_id: string) {
    const { initialDate, endDate } = dateRange;
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', 'Bearer ' + this.loginService.getAuthInformation().token);
    return this.http.get(
      `${this.api_uri}${this.BASE_URL}/lead/distribution/agent?max_results=${maxResults}&page=${page}&order=${order}&dtIni=${initialDate}&dtEnd=${endDate}&company_id=${company_id}`,
       {headers}
    );
  }

  public getCompaniesList() {
    return this.http.get<any>(`${this.api_uri}/companies`);
  }
}
